/* import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import { useState } from "react";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

const DashboardLineChart = ({ label, profit, expenses, currency, xAxisLabel }) => {
  const isMobile = window.innerWidth <= 568; // Example breakpoint for mobile devices
  console.log(isMobile, "isMobile");

  const yValue = [...profit, ...expenses].map((val) => Number(val) || 0);
  const maxY = Math.max(0, ...yValue);
  const stepSize = maxY === 0 ? 10 : Math.ceil(maxY / 50);

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

  ChartJS.defaults.font.family = "Nunito";
  ChartJS.defaults.font.size = 10;

  //number formatting


  const options = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),

          stepSize: stepSize,
        },
        title: {
          display: isMobile ? false : true,
          text: "Profit in " + "(" + currency + ")",
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: xAxisLabel ,
        },
      },
    },
  };

  const labels = label.slice(0, -1);
  const lineToolTip = {
    id: "lineToolTip",
    afterDraw: (chart) => {
      if (chart.tooltip._active && chart.tooltip._active.length) {
        const activePoint = chart.tooltip._active[0];
        const ctx = chart.ctx;
        const x = activePoint.tooltipPosition().x;
        const topY = chart.scales["y"].top;
        const bottomY = chart.scales["y"].bottom;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#0E49B5";
        ctx.stroke();
        ctx.restore();
      }
    },
  };

  const plugins = [lineToolTip];
  const data = {
    labels,
    datasets: [
      {
        label: "Profit ",
        data: profit.slice(0, -1),
        borderColor: "#5887DE",
       
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const area = chart.chartArea;
          if (!area) {
            // before first draw, fallback to a solid color
            return "rgba(88, 135, 222, 0.4)";
          }
          const { top, bottom } = area;
          const grad = chart.ctx.createLinearGradient(0, top, 0, bottom);
          grad.addColorStop(0, "rgba(88, 135, 222, 0.2)");
          grad.addColorStop(1, "rgba(88, 135, 222, 0)");
          return grad;
        },
        tension: 0.25,
        borderWidth: 1.4,
        pointRadius: 0.5,
        fill: true,
      },
      {
        label: "Expense ",
        data: expenses.slice(0, -1),
        borderColor: "#ff8080",
        backgroundColor: "#ff8080",
        tension: 0.3,
        borderWidth: 1.4,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className='line-chartDashb'>
      <Line height={256} data={data} options={options} />
    </div>
  );
};

export default DashboardLineChart;
 */

import { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

/*
  DashboardLineChart
  ──────────────────
  Props:
    label      — string[]  x-axis labels (e.g. hours or dates)
    profit     — number[]
    expenses   — number[]
    currency   — string    e.g. "₦" or "kr"
    xAxisLabel — string    label shown below x-axis
*/
export default function DashboardLineChart({ label = [], profit = [], expenses = [], currency = "₦", xAxisLabel = "" }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  const fmtVal = (v) => {
    if (v >= 1e6) return currency + (v / 1e6).toFixed(1) + "M";
    if (v >= 1e3) return currency + (v / 1e3).toFixed(0) + "K";
    return currency + v.toLocaleString();
  };

  useEffect(() => {
    if (!canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    chartRef.current = new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels: label,
        datasets: [
          {
            label: "Profit",
            data: profit,
            borderColor: "#1e3a5f",
            backgroundColor: "rgba(30,58,95,0.07)",
            fill: true,
            tension: 0.4,
            pointRadius: 3,
            pointBackgroundColor: "#1e3a5f",
            pointHoverRadius: 5,
            borderWidth: 2,
          },
          {
            label: "Expense",
            data: expenses,
            borderColor: "#f06292",
            borderDash: [5, 4],
            fill: false,
            tension: 0.4,
            pointRadius: 2,
            pointBackgroundColor: "#f06292",
            pointHoverRadius: 4,
            borderWidth: 1.5,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => ` ${ctx.dataset.label}: ${fmtVal(ctx.raw)}`,
            },
          },
        },
        scales: {
          x: {
            grid: { color: "rgba(0,0,0,0.05)" },
            ticks: { color: "rgba(0,0,0,0.35)", font: { size: 10 }, maxRotation: 0, maxTicksLimit: 8 },
            title: xAxisLabel ? { display: true, text: xAxisLabel, color: "#7a8fab", font: { size: 11 } } : { display: false },
          },
          y: {
            grid: { color: "rgba(0,0,0,0.05)" },
            ticks: { color: "rgba(0,0,0,0.35)", font: { size: 10 }, callback: fmtVal },
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [label, profit, expenses, currency, xAxisLabel]);

  return (
    <div style={{ position: "relative", width: "100%", height: 200 }}>
      <canvas ref={canvasRef} role='img' aria-label='Profit vs expense line chart' />
    </div>
  );
}
